import React, { useState, useEffect } from "react";
import PatientCard from "../../../shared/cards/PatientCard"
import CommonFormBuilder from "../../CommonComponenets/FormBuilder";

const mainContent = {};

const PP_OB_OPTIONS = [
  { value: "in_patient", label: { en: "In Patient", ms: "Pesakit Dalam" } },
  { value: "out_patient", label: { en: "Out Patient", ms: "Pesakit Luar" } }
];

const LAB_OPTIONS = [
  { value: "inhouse", label: { en: "Inhouse", ms: "Dalam Rumah" } },
  { value: "out_source", label: { en: "Out source", ms: "Sumber Luar" } }
];

const DOCTOR_OPTIONS = [
  { value: "dr_afif", label: { en: "Dr. Afif", ms: "Dr. Afif" } },
  { value: "dr_faez", label: { en: "Dr. Faez", ms: "Dr. Faez" } },
  { value: "dr_azril", label: { en: "Dr. Azril", ms: "Dr. Azril" } }
];

const LOCATION_OPTIONS = [
  { value: "tsw", label: { en: "TSW", ms: "TSW" } },
  { value: "dpw", label: { en: "DPW", ms: "DPW" } },
  { value: "premier_clinic", label: { en: "Premier Clinic", ms: "Klinik Premier" } },
  { value: "general_clinic", label: { en: "General Clinic", ms: "Klinik Am" } },
  { value: "premier_ward", label: { en: "Premier Ward", ms: "Wad Premier" } },
  { value: "general_ward", label: { en: "General ward", ms: "Wad Am" } },
  { value: "cvw", label: { en: "CVW", ms: "CVW" } },
  { value: "hb3", label: { en: "HB3", ms: "HB3" } }
];

const MEAL_OPTIONS = [
  { value: "fasting", label: { en: "Fasting", ms: "Berpuasa" } },
  { value: "random", label: { en: "Random", ms: "Tidak Berpuasa" } },
  { value: "others", label: { en: "Others", ms: "Lain-lain"}}
];

const PROFILE_TEST_OPTIONS = [
  { value: "rft", label: { en: "RFT", ms: "RFT" } },
  { value: "cbc", label: { en: "CBC", ms: "CBC" } },
  { value: "tft", label: { en: "TFT", ms: "TFT" } },
  { value: "rp", label: { en: "RP", ms: "RP" } },
  { value: "bmp", label: { en: "BMP", ms: "BMP" } },
  { value: "lp", label: { en: "LP", ms: "LP" } },
  { value: "others", label: { en: "Others", ms: "Lain-lain" } }
];

const BIOCHEMISTRY_OPTIONS = [
  { value: "hba1c", label: { en: "HbA1c", ms: "HbA1c" } },
  { value: "psa", label: { en: "PSA", ms: "PSA" } },
  { value: "hiv", label: { en: "HIV 1&2", ms: "HIV 1&2" } },
  { value: "afp", label: { en: "AFP", ms: "AFP" } },
  { value: "cea", label: { en: "CEA", ms: "CEA" } },
  { value: "others", label: { en: "Others", ms: "Lain-lain" } }
];

const HEMATOLOGY_OPTIONS = [
  { value: "fbc", label: { en: "FBC", ms: "FBC" } },
  { value: "hb", label: { en: "HB", ms: "HB" } },
  { value: "esr", label: { en: "ESR", ms: "ESR" } },
  { value: "others", label: { en: "Others", ms: "Lain-lain" } }
];

const MICROBIOLOGY_OPTIONS = [
  { value: "ufeme", label: { en: "UFEME", ms: "UFEME" } },
  { value: "urine_cs", label: { en: "Urine C&S", ms: "Urin C&S" } },
  { value: "microscopy", label: { en: "Microscopy", ms: "Mikroskopi" } },
  { value: "others", label: { en: "Others", ms: "Lain-Lain" } }
];

const SPECIMEN_OPTIONS = [
  { value: "sputum", label: { en: "Sputum", ms: "Kahak" } },
  { value: "faeces", label: { en: "Faeces", ms: "Najis" } },
  { value: "others", label: { en: "Others", ms: "Lain-Lain" } }
];

const NOTIFY_DOCTOR_OPTIONS = [
  { value: "yes", label: { en: "Yes", ms: "Ya" } },
  { value: "no", label: { en: "No", ms: "Tidak" } }
];

const formatDate = (d) => {
  if (!d) return "-";
  const x = typeof d === "string" ? new Date(d) : d;
  return isNaN(x.getTime()) ? "-" : x.toLocaleDateString();
};

export default function LabRequestForm({ patient, onBack }) {
  const [language, setLanguage] = useState("en");
  const name = patient?.name || patient?.patient_name || "-";
  const address = patient?.residence || patient?.address || "-";
  const dob = patient?.dob || patient?.date_of_birth || patient?.birth_date;
  const gender = patient?.sex || patient?.gender || "-";

  const [values, setValues] = useState({
    pp_ob: "",
    lab: "",
    requester_name: "",
    requester_telephone: "",
    location: "",
    requester_date: "",
    requester_time: "",
    patient_name: name,
    patient_address: address,
    patient_dob: dob ? formatDate(dob) : "-",
    patient_gender: gender,
    meal: "",
    profile_test: [],
    profile_test_others: "",
    biochemistry: [],
    biochemistry_others: "",
    hematology: [],
    hematology_others: "",
    microbiology: [],
    microbiology_others: "",
    specimen: [],
    specimen_others: "",
    others: "",
    result_upload: null,
    notify_doctor: ""
  });
  const [patientHistory, setPatientHistory] = useState({
    past_medical_history: "",
    past_family_history: "",
    alerts_and_allergies: ""
  });
  const storageKey = patient
    ? `psychology_assessment_draft_${patient.id}`
    : null;

 useEffect(() => {
    if (!storageKey) return;
    const saved = localStorage.getItem(storageKey);
    if (saved) setValues(JSON.parse(saved).values || {});
  }, [storageKey]);


 useEffect(() => {
        if (!patient) return;
        setPatientHistory({
          past_medical_history: patient.medical_history || "",
          past_family_history: patient.family_medical_history || "",
          alerts_and_allergies: patient.alerts_and_allergies_history || ""
        });
      }, [patient]);
  useEffect(() => {
    if (patient) {
      const dobRaw = patient.dob || patient.date_of_birth || patient.birth_date || "";
      const dobFormatted = dobRaw ? formatDate(dobRaw) : "-";
      setValues(v => ({
        ...v,
        patient_name: patient.name || patient.patient_name || "-",
        patient_address: patient.residence || patient.address || "-",
        patient_dob: dobFormatted,
        patient_gender: patient.sex || patient.gender || "-"
      }));
    }
  }, [patient]);

  const onChange = (name, value) => setValues(v => ({ ...v, [name]: value }));

  // const PATIENT_SCHEMA = {
  //   title: "Patient Information",
  //   sections: []
  // }
  function PatientInformationBlock({ patient, patientHistory, setPatientHistory }) {
  if (!patient) return null;

  const safe = (v) => v ?? "-";
  const formatDate = (d) => d ? new Date(d).toLocaleDateString() : "-";

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 12,
        fontSize: 14
      }}>
        <div><b>Name:</b> {safe(patient.name)}</div>
        <div><b>IC:</b> {safe(patient.id)}</div>
        <div><b>DOB:</b> {formatDate(patient.dob)}</div>

        <div><b>Age / Gender:</b> {safe(patient.age)} / {safe(patient.sex)}</div>
        <div><b>ICD:</b> {safe(patient.icd)}</div>
        <div><b>Date of Assessment:</b> {new Date().toLocaleDateString()}</div>

        <div><b>Date of Onset:</b> {formatDate(patient.date_of_onset)}</div>
        <div><b>Duration of Diagnosis:</b> -</div>
        <div><b>Primary Diagnosis:</b> {safe(patient.diagnosis_history)}</div>

        <div><b>Secondary Diagnosis:</b> {safe(patient.medical_history)}</div>
        <div><b>Dominant Side:</b> {safe(patient.dominant_side)}</div>
        <div><b>Language Preference:</b> {safe(patient.language_preference)}</div>

        <div><b>Education Level:</b> {safe(patient.education_background)}</div>
        <div><b>Occupation:</b> {safe(patient.occupation)}</div>
        <div><b>Work Status:</b> {safe(patient.employment_status)}</div>

        <div><b>Driving Status:</b> {safe(patient.driving_status)}</div>
        <div><b>PP/OB:</b> {safe(patient.pp_ob)}</div>
        <div><b>Weight:</b> {patient.weight ? `${patient.weight} kg` : "-"}</div>

        {/* ===== HISTORY ===== */}
        <div style={{ gridColumn: "1 / -1", marginTop: 10 }}>
        
           <h3>Patient History</h3>
        
                  <div>
                    <b>Past Medical History</b>
                    <textarea
                      style={textarea}
                      value={patientHistory.past_medical_history}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          past_medical_history: e.target.value
                        }))
                      }
                    />
                  </div>

          
          <div>
                    <b>Family History</b>
                    <textarea
                      style={textarea}
                      value={patientHistory.past_family_history}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          past_family_history: e.target.value
                        }))
                      }
                    />
                  </div>

        
           <div>
                    <b>Allergies</b>
                    <textarea
                      style={textarea}
                      value={patientHistory.alerts_and_allergies}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          alerts_and_allergies: e.target.value
                        }))
                      }
                    />
                  </div>

          <button style={alertBtn}>🚨 Alerts</button>
        </div>
      </div>
    </div>
  );
}

  const LAB_SCHEMA = {
    enableLanguageToggle: true,
    title: { en: "Lab Request Form", ms: "Borang Permintaan Makmal" },
    actions: [
      { type: "toggle-language" },
      { type: "back", label: { en: "Back", ms: "Kembali" } }
    ],
    sections: [
      {
        fields: [
          { type: "subheading", label: { en: "Sample details", ms: "Butiran Sampel" } },
          { name: "lab", label: { en: "Lab", ms: "Makmal" }, type: "radio", options: LAB_OPTIONS },
          { name: "location", label: { en: "Location", ms: "Lokasi" }, readOnly: true, type: "single-select", options: LOCATION_OPTIONS },
          {
            type: "row",
            fields: [
            { name: "requester_date", label: { en: "Date", ms: "Tarikh" }, type: "date" },
            { name: "requester_time", label: { en: "Time", ms: "Masa" }, type: "input", placeholder: { en: "HH:MM", ms: "HH:MM" } }
            ]
          },
          { name: "meal", label: { en: "Meal", ms: "Makanan" }, type: "radio", options: MEAL_OPTIONS },          { name: "meal_others", label: "Others", type: "textarea",
            showIf: { field: "meal", equals: "others"}
          },
          { type: "subheading", label: { en: "Profile Test", ms: "Ujian Profil" } },
          {
            name: "profile_test",
            label: "",
            type: "checkbox-group",
            inlineWithLabel: true,
            options: PROFILE_TEST_OPTIONS
          },
          {
            name: "profile_test_others",
            label: { en: "Specify Other", ms: "Nyatakan Lain-lain" },
            type: "input",
            placeholder: { en: "Enter details", ms: "Masukkan butiran" },
            showIf: { field: "profile_test", includes: "others" }
          },
          { type: "subheading", label: { en: "Biochemistry", ms: "Biokimia" } },
          {
            name: "biochemistry",
            label: "",
            type: "checkbox-group",
            inlineWithLabel: true,
            options: BIOCHEMISTRY_OPTIONS
          },
          {
            name: "biochemistry_others",
            label: { en: "Specify Other", ms: "Nyatakan Lain-lain" },
            type: "input",
            placeholder: { en: "Enter details", ms: "Masukkan butiran" },
            showIf: { field: "biochemistry", includes: "others" }
          },
          { type: "subheading", label: { en: "Hematology", ms: "Hematologi" } },
          {
            name: "hematology",
            label: "",
            type: "checkbox-group",
            inlineWithLabel: true,
            options: HEMATOLOGY_OPTIONS
          },
          {
            name: "hematology_others",
            label: { en: "Specify Other", ms: "Nyatakan Lain-lain" },
            type: "input",
            placeholder: { en: "Enter details", ms: "Masukkan butiran" },
            showIf: { field: "hematology", includes: "others" }
          },
          { type: "subheading", label: { en: "Microbiology", ms: "Mikrobiologi" } },
          {
            name: "microbiology",
            label: "",
            type: "checkbox-group",
            inlineWithLabel: true,
            options: MICROBIOLOGY_OPTIONS
          },
          {
            name: "microbiology_others",
            label: { en: "Specify Other", ms: "Nyatakan Lain-lain" },
            type: "input",
            placeholder: { en: "Enter details", ms: "Masukkan butiran" },
            showIf: { field: "microbiology", includes: "others" }
          },
          { type: "subheading", label: { en: "Specimen", ms: "Spesimen" } },
          {
            name: "specimen",
            label: "",
            type: "checkbox-group",
            inlineWithLabel: true,
            options: SPECIMEN_OPTIONS
          },
          {
            name: "specimen_others",
            label: { en: "Specify Other", ms: "Nyatakan Lain-lain" },
            type: "input",
            placeholder: { en: "Enter details", ms: "Masukkan butiran" },
            showIf: { field: "specimen", includes: "others" }
          },
          { name: "others", label: { en: "Others", ms: "Lain-Lain" }, type: "textarea", placeholder: { en: "Free text", ms: "Teks bebas" } },
          {
            name: "result_upload",
            title: { en: "Upload The Result", ms: "Muat Naik Keputusan" },
            type: "attach-file",
            accept: "image/*,.pdf"
          },
          { name: "notify_doctor", label: { en: "Notify Doctor", ms: "Maklumkan Doktor" }, type: "radio", options: NOTIFY_DOCTOR_OPTIONS }
        ]
      }
    ]
  };

  const handleAction = (type) => {
    if (type === "toggle-language") {
      setLanguage(l => (l === "en" ? "ms" : "en"));
    }
    if (type === "back") onBack?.();
  };

  return (
    <div style={mainContent}>
  <CommonFormBuilder
          schema={{ title: "Patient Information", sections: [] }}
          values={{}}
          onChange={() => {}}
        >
          <PatientInformationBlock
            patient={patient}
            patientHistory={patientHistory}
            setPatientHistory={setPatientHistory}
          />
        
          <button style={doctorsReportBtn}>
            Doctors Reports
          </button>
        </CommonFormBuilder>
      <CommonFormBuilder
        schema={LAB_SCHEMA}
        values={values}
        onChange={onChange}
        onAction={handleAction}
        language={language}
      />
    </div>
  );
}

const doctorsReportBtn = {
  padding: "10px 20px",
  background: "#2563EB",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
  marginTop: 8
};

const textarea = {
          width: "100%",
          minHeight: 90,
          marginTop: 6,
          marginBottom: 12,
          padding: "10px 12px",
          borderRadius: 6,
          border: "1px solid #d1d5db",
          fontSize: 14,
          resize: "vertical"
};
const alertBtn = {
  marginTop: 10,
          padding: "10px 20px",
          borderRadius: 6,
          border: "1.5px solid #007bff",
          background: "#007bff",
          color: "#fff",
          fontWeight: 600,
          cursor: "pointer"
};
